module.exports = __webpack_public_path__ + "img/C_n.97082f88.png";